<template>
  <!-- 分享详情 -->
  <div class="discovery_details_info">
    <div v-if="formData.status!='REJECTED'&& formData.isDeleted=='n'">
      <shareBtn v-show="isShareCome || $route.query && $route.query.sharetype =='browser'" pageCode="5011001" v-isNoAppShare/>
      <swipeInfo :item="formData.fileList" :bees="formData"/>
      <commodityCard :item="formData" v-if="formData && formData.discoverType=='PREPARE'"/>
      <shopperItem :item="formData" :beesInfo="beesInfo"/>
    </div>
    <div v-if="formData.status=='REJECTED' || formData.isDeleted=='y'">
      <emptyItem/>
    </div>
  </div>
</template>
<script>
import headerTitle from "./components/headerTitle";
import swipeInfo from "./components/swipeInfo";
import shareItem from "./components/shareItem";
import shopperItem from "./components/shopperItem";
import commodityCard from "./components/commodityCard";
import emptyItem from "./components/emptyItem";
import shareBtn from "./components/shareBtn";
import http from "@/utils/axios";
export default {
  data() {
    return {
      formData:{},
      beesInfo:{},
    };
  },
  methods: {
    getDetails(){
      let discoverId =  this.$route.query && this.$route.query.id ?this.$route.query.id :this.$route.query.discoverId
      http({
        url:'/discover/appbees/discover/content/detail',
        method:'POST',
        parmes:{
          discoverId:discoverId
        }
      }).then(rps=>{
        if(rps.code==200){
          this.formData = rps.data;
        }
      })
    }
  },
  components: {
    headerTitle,
    shareItem,
    shopperItem,
    commodityCard,
    emptyItem,
    swipeInfo,
    shareBtn
  },
  created(){
    this.getDetails();
    this.$loading.hide();
  }
};
</script>
<style lang="less" scoped>
.discovery_details_info {
  margin-bottom: 100px;
}
</style>